import { Controller } from "@hotwired/stimulus";
import { dispatchFilterUpdatedEvent } from "../../datatables/datatable_filters";
import { toggleClass } from "../../utils/misc";
import { isEnterKey } from "../../utils/inputs_utils";

export default class extends Controller {
  static targets = ["textInput", "errorMessage", "form"];
  static outlets = ["datatables--selected-filter"];

  connect() {
    if (this.hasDatatablesSelectedFilterOutlet) {
      this.datatablesSelectedFilterOutlet.displayContent(this._translatedValue());
    }
  }

  filterInputChanged(event) {
    if (isEnterKey(event.keyCode)) {
      this.filterChanged();
    }
  }

  filterChanged() {
    const isFilterValid = this.formTarget.checkValidity();
    toggleClass(this.errorMessageTarget, "hidden", !isFilterValid);

    if (isFilterValid) {
      this.datatablesSelectedFilterOutlet.displayContent(this._translatedValue());
      this._filterUpdated();
    }
  }

  _filterUpdated() {
    const { filterName } = this.element.dataset;

    dispatchFilterUpdatedEvent({ name: filterName });
  }

  _translatedValue() {
    return this.textInputTarget.value;
  }
}
